import type React from 'react';

import type { IdSalesPromotionDto } from '@/services/ws-funnel/src/main/resources/rest-api/types';
import { Link } from '@/js/libs/ui';

import type { PromotionPage } from '../promotionPage';
import { DEFAULT_PROMOTION_PAGE } from '../promotionPage';

type LinkComponent<AdditionalProps = unknown> = React.FC<React.PropsWithChildren<{ className?: string }> & AdditionalProps>;

const List: LinkComponent = ({ ...props }) => <Link to='/sales/promotions' {...props} />;

const Promotion: LinkComponent<{ promotionId: IdSalesPromotionDto; page?: PromotionPage }> = ({
  promotionId,
  page = DEFAULT_PROMOTION_PAGE,
  ...rest
}) => <Link to={`/sales/promotions/${promotionId}/${page}`} {...rest} />;

export const PromotionLink = {
  List,
  Promotion,
};
